import type { VFC } from 'react';

import { ErrorView } from './ErrorView';

const NoPermissionView: VFC = () => (
  <ErrorView
    buttonText="Back to home"
    linkTo="/"
    pageTitle="Access denied"
    subTitle="You either tried some shady route or you came here by mistake. Whichever it is, try using the navigation."
    title="Seems like you do not have the required permission for this page"
  />
);

export default NoPermissionView;
